import { createAttachedSignature } from "crypto-pro";

import { message } from "antd";
import { getFileNameWithoutExtention } from "../documents/getFileNameWithoutExtention";

interface getSignedFileParams {
  fileName?: string;
  file: Blob;
  thumbprint: string;
}

/**
 *Возвращает прикрепленную подпись файла в формате .sig
 *В него вшиты исходный файл и подпись
 *
 * @param fileName Имя файла для подписания
 * @param file файл с бэка (Blob)
 * @param thumbprint код из данных ЭЦП
 * @returns подписанный файл в формате .sig
 */

export const getSignedFile = async ({
  fileName,
  file,
  thumbprint,
}: getSignedFileParams) => {
  try {
    const buf = await file.arrayBuffer();
    const signature = await createAttachedSignature(thumbprint, buf);
    const signedFile = new File(
      [signature],
      `${getFileNameWithoutExtention(fileName)}.sig`,
      {
        type: "application/pgp-signature",
      }
    );

    return signedFile;
  } catch (error: unknown) {
    if (error instanceof Error) {
      message.error("Не удалось подписать документ");
      throw new Error(error.message);
    }
  }
};
